
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { DeepackListRequest, DeepackListResponse, DeliverRequest, DepackFeedstockLoadScheduleByIdResponse, DepackFeedstockLoadScheduleWithStreamsByIdResponse, DepackStreamGridResponse, DispatchLoads, FeedStockDispatchDetails, FeedstockListRequest, FeedStockLoadInfoResponse, FeedStockLoadScheduleDispatchDataResponse, FeedstockLoadScheduleResponse, FSLoadStatus, GetDeepackOutboundByIdResponse, GetDeepackOutboundRequest, GetDeepackOutboundResponse, SaveDepackFeedstockLoadScheduleRequest, SaveFeedstockLoadScheduleRequest, SiteWithAddressResponse, UpdateFeedStockSampleStatusRequest } from '../interfaces/feedstocklistmodel';
import { environment } from '../environments/environment';
import { IdName } from '../interfaces/pricematrixmodel';
import {   FeedStockLoadDocumentResponse } from '../interfaces/pricematrixmodel';
@Injectable({
  providedIn: 'root'
})
export class DepackService {

  baseUrl = environment.baseUrl + 'feedstocks/';

  constructor(private http: HttpClient) { }

  getDepackSites(): Observable<any[]> {
    return this.http.get<any[]>(`${this.baseUrl}GetDepackSites`);
  }
  getDepackCustomers(siteId: number): Observable<IdName[]> {
    return this.http.get<IdName[]>(`${this.baseUrl}GetDepackCustomers?siteId=${siteId}`);
  }
  getDepackCustomerLocations(customerId: number): Observable<IdName[]> {
    return this.http.get<IdName[]>(`${this.baseUrl}GetCustomerLocations?customerId=${customerId}`);
  }

  getDepackFeeCategories(): Observable<IdName[]> {
    return this.http.get<IdName[]>(`${this.baseUrl}GetDeepackFeeCategories`);
  }
  getDisposalSites(): Observable<any[]> {
    return this.http.get<any[]>(`${this.baseUrl}GetDepackSites`);
  }

  getDirectionsList(): Observable<IdName[]>{
    var retData = [
      {id: -1, name: 'All'},
      {id: 0, name: 'Inbound'},
      {id: 1, name: 'Outbound'},
    ];
    return of(retData);
  }

  getLoadTypes(): Observable<any>{
    var retData = [
      { value: 2, label: 'All' },
      { value: 1, label: 'Revenue' },
      { value: 0, label: 'Expense' }
    ];
    return of(retData);
  }

  getCustomers(): Observable<any[]> {
    return this.http.get<any[]>(`${this.baseUrl}GetDepackCustomers`);
  }
  getCustomersBySite(siteId: string): Observable<any[]> {
    return this.http.get<any[]>(`${this.baseUrl}GetDepackCustomers?SiteId=${siteId}`);
  }
  getCustomerLocations(customerId: number): Observable<any[]> {
    return this.http.get<any[]>(`${this.baseUrl}GetCustomerLocations?customerId=${customerId}`);
  }

  getMaterialStreamsLoads(customerId: number): Observable<any[]> {
    return this.http.get<any[]>(`${environment.baseUrl}streams/GetMaterialStreamsLoads?customerId=${customerId}`);
  }
  getDepackList(request: DeepackListRequest): Observable<DeepackListResponse[]> { 

    const params = new URLSearchParams();
    params.append('marketId', request.marketId.toString());
    params.append('siteId', request.siteId.toString());
    params.append('fromDate', request.fromDate ?? '');
    params.append('toDate', request.toDate ?? '');
    params.append('statusId', request.statusId.toString());
    params.append('loadType', request.loadType);
    params.append('loadDirection', request.loadDirection);

    var url = `${this.baseUrl}GetFeedstockLoadScheduleDeepack?${params.toString()}`;
    return this.http.get<DeepackListResponse[]>(url);
  }

   getDeepackOutboundStreams(id: number):Observable<any[]>{
    return this.http.get<any[]>(`${environment.baseUrl}feedstocks/GetDeepackOutboundStreams?customerId=${id}`);
  }

  getShipFrom(): Observable<SiteWithAddressResponse[]> {
    return this.http.get<SiteWithAddressResponse[]>(`${environment.baseUrl}masters/GetDeepackOutboundShipFrom`);
  }

  getShipTo(): Observable<SiteWithAddressResponse[]> {
    return this.http.get<SiteWithAddressResponse[]>(`${environment.baseUrl}masters/GetDeepackOutboundShipTo`);
  }

  getDepackOutboundById(id: number): Observable<GetDeepackOutboundByIdResponse>{
    return this.http.get<GetDeepackOutboundByIdResponse>(`${environment.baseUrl}feedstocks/GetDeepackOutboundById?id=${id}`);
  }

  getdepackOutboundGridById(id: number): Observable<any[]>{
    return this.http.get<any[]>(`${environment.baseUrl}feedstocks/GetDeepackOutboundAdditionalStreamsById?id=${id}`);
  }

  saveDeepackOutbound(payload: any):Observable<number>{
    const saveApiUrl = environment.baseUrl + 'feedstocks/SaveDeepackOutbound';
    return this.http.post<number>(saveApiUrl, payload);
  }

  getDepackOutboundData(request: GetDeepackOutboundRequest): Observable<GetDeepackOutboundResponse[]>{
    return this.http.post<GetDeepackOutboundResponse[]>(
      `${this.baseUrl}GetDeepackOutbound`,
      request
    );
  }

  getDepackLoadById(loadScheduleId:number):Observable<DepackFeedstockLoadScheduleWithStreamsByIdResponse>{
     var url = `${this.baseUrl}GetFeedstockloadscheduleByIdDeepack?loadScheduleId=${loadScheduleId}`;
    return this.http.get<DepackFeedstockLoadScheduleWithStreamsByIdResponse>(url);
  }

   getDeepackStreamsByLoadId(fsLoadId:number):Observable<DepackStreamGridResponse[]>{
    var url = `${this.baseUrl}GetFSloadscheduleAdditionalStreamsByIdDeepack?fsid=${fsLoadId}`;    
    return this.http.get<DepackStreamGridResponse[]>(url);
  }
  getDeepackStreamsById(fsLoadId:number):Observable<DepackStreamGridResponse>{
    var url = `${this.baseUrl}GetFSloadscheduleAdditionalStreamsByIdDeepack?fsid=${fsLoadId}`;    
    return this.http.get<DepackStreamGridResponse>(url);
  }
   getStreamsForDepack(customerId:number,locName:string, hid:string, sid:string): Observable<IdName[]> {
    var url = `${this.baseUrl}GetMaterialStreamsDepackloads?generatorId=${customerId}
    &locName=${locName}&hid=${hid}&sid=${sid}`;    
    return this.http.get<IdName[]>(url);
  }

  saveDepackLoad(payload:FormData){
    var url = `${this.baseUrl}SaveFeedstockLoadScheduleDeepack`
    return this.http.post<any>(url, payload);
  }
  getDocuments(id: number, screenTypeId: number): Observable<FeedStockLoadDocumentResponse[]> {
    var url = `${this.baseUrl}GetDocumentDetails?FS_LoadScheduleId=${id}&ScreenTypeId=${screenTypeId}`;
    return this.http.get<FeedStockLoadDocumentResponse[]>(url);
 }
}
